// extracted by mini-css-extract-plugin
export default {"tag":"inputProfilesButton_tag__CLhXq","infoBlock":"inputProfilesButton_infoBlock__FBbNi","avatar":"inputProfilesButton_avatar__ZhPUO","tagText":"inputProfilesButton_tagText__erz+n"};